import React, { FC } from 'react'

import { Carousel, GRID_UNIT } from 'mf-ui-components'

import { CarouselDots } from '../../../../common/CarouselDots'
import { BlogPost } from '../BlogPost'
import { BlogPost as BlogPostType } from '../types'
import { Container } from './BlogPostsMobile.styles'

type Props = {
  entries: BlogPostType[]
  id?: string
  className?: string
}

export const BlogPostsMobile: FC<Props> = ({
  entries,
  ...props
}) => (
  <Container {...props}>
    <Carousel
      autoplay
      wrapAround
      pauseOnHover
      speed={800}
      cellSpacing={GRID_UNIT * 2}
      autoplayInterval={4_000}
      renderBottomCenterControls={({ currentSlide, goToSlide }: any) => (
        <CarouselDots
          amount={entries.length}
          current={currentSlide % entries.length}
          onClick={goToSlide}
        />
      )}
    >
      {entries.map(entry => (
        <BlogPost key={entry.title} {...entry} />
      ))}
    </Carousel>
  </Container>
)
